import ApiBaseService from './ApiBaseService';

class TimesheetService {

    // * Employee
    static getTimesheet([company_uuid, employee_uuid, startDate, endDate]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet?type=week&startDate=${encodeURIComponent(
                startDate
            )}&endDate=${encodeURIComponent(endDate)}&pagination=0`,
            'GET'
        );
    }

    static getTimesheets([company_uuid, employee_uuid, type, startDate, endDate]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet?type=${type}&startDate=${encodeURIComponent(
                startDate
            )}&endDate=${encodeURIComponent(endDate)}&pagination=0`,
            'GET'
        );
    }

    static getMonthChart([company_uuid, employee_uuid, startDate, endDate]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet-project-analysis?startDate=${encodeURIComponent(
                startDate
            )}&endDate=${encodeURIComponent(endDate)}`,
            'GET'
        );
    }

    static getTimesheetProjects([company_uuid, employee_uuid, startDate, endDate]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet-projects?startDate=${encodeURIComponent(
                startDate
            )}&endDate=${encodeURIComponent(endDate)}`,
            'GET'
        );
    }

    static getTimesheetDetails([company_uuid, employee_uuid, timesheet_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/timesheet/${timesheet_uuid}`, 'GET');
    }

    static updateTimesheet([company_uuid, employee_uuid, timesheet_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/timesheet/${timesheet_uuid}`, 'PUT', data);
    }

    static submitTimesheet([company_uuid, employee_uuid, startDate, endDate]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet-submit?startDate=${encodeURIComponent(
                startDate
            )}&endDate=${encodeURIComponent(endDate)}`,
            'PUT'
        );
    }

    static addTask([company_uuid, employee_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/timesheet`, 'POST', data);
    }

    static deleteTask([company_uuid, employee_uuid, timesheet_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/timesheet/${timesheet_uuid}`, 'DELETE');
    }

    static getBlockedLeaves([company_uuid, employee_uuid, startDate, endDate]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leave-block-dates?startDate=${startDate}&endDate=${endDate}`, 'GET');
    }

    // * Timed Task
    static punchIn([company_uuid, employee_uuid, timesheet_uuid]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet/${timesheet_uuid}/punch/start`,
            'PUT'
        );
    }

    static punchPause([company_uuid, employee_uuid, timesheet_uuid]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet/${timesheet_uuid}/punch/pause`,
            'PUT'
        );
    }

    static punchStop([company_uuid, employee_uuid, timesheet_uuid]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/timesheet/${timesheet_uuid}/punch/stop`,
            'PUT'
        );
    }

    static leaveSummary([company_uuid, employee_uuid, startYear]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leave-summary?startYear=${startYear}`, 'GET');
    }

    static leaveList([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0, startYear]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leave?type=all&pagination=${pagination}&page=${page}&limit=${limit}&startYear=${startYear}`, 'GET');
    }

    static leaveRequest([company_uuid, employee_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leave`, 'POST', data);
    }

    static leaveDetails([company_uuid, employee_uuid, leave_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leave/${leave_uuid}`, 'GET');
    }

    static updateLeave([company_uuid, employee_uuid, leave_uuid, data]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/leave/${leave_uuid}`, "PUT", data);
    }

    static deleteLeave([company_uuid, employee_uuid, leave_uuid]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/leave/${leave_uuid}`, "DELETE");
    }

    static getEmployeeLeaveApprovalList([company_uuid, employee_uuid, type, startDate, endDate, pagination = 0, page = 0, limit = 0, employee = '']) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/approval/leave?type=${type}&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}&page=${page}&limit=${limit}${employee ? `&employee=${employee}` : ''}`,
            'GET'
        );
    }

    static getEmployeePendingList([company_uuid, employee_uuid]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/approval/employees-leave-pending`,
            'GET'
        );
    }

    static getEmployeeTeam([company_uuid, employee_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/approval/employees`, 'GET');
    }

    static reviewEmployeeLeave([company_uuid, employee_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/approval/leave`, 'PUT', data);
    }

    static getEmployeeLeaveReport([company_uuid, employee_uuid, type]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/leave-report?type=${type}`,
            'GET'
        );
    }

    static getEmployeeReviewList([company_uuid, employee_uuid, type, startDate, endDate, employeeUuid]) {
        let url = `/api/company/${company_uuid}/employee/${employee_uuid}/approval/timesheet?type=${type}&startDate=${startDate}&endDate=${endDate}&pagination=0`;
        if (employeeUuid) {
            url += `&employee=${employeeUuid}`;
        }
        return ApiBaseService.request(url, 'GET');
    }

    static reviewEmployeeTimesheet([company_uuid, employee_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/approval/timesheet`, 'PUT', data);
    }

    // * Employer / Manager Approvals

    static getLeaveApprovalList([company_uuid, type, startDate, endDate, pagination = 0, page = 0, limit = 0, employee = '']) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/approval/leave?type=${type}&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}&page=${page}&limit=${limit}${employee ? `&employee=${employee}` : ''}`,
            'GET'
        );
    }

    static getCompanyPendingEmployeeList([company_uuid]) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/approval/employees-leave-pending`,
            'GET'
        );
    }

    static getCompanyLeaveReport([company_uuid, type, startDate, endDate, employee = '']) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/approval/leave-report?type=${type}&startDate=${startDate}&endDate=${endDate}${employee ? `&employee=${employee}` : ''}`,
            'GET'
        );
    }

    static getEmployeerLeaveReport([company_uuid, employee_uuid, type, startDate, endDate, employee = '']) {
        return ApiBaseService.request(
            `/api/company/${company_uuid}/employee/${employee_uuid}/approval/leave-report?type=${type}&startDate=${startDate}&endDate=${endDate}${employee ? `&employee=${employee}` : ''}`,
            'GET'
        );
    }

    static reviewCompanyLeave([company_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/approval/leave`, 'PUT', data);
    }

    static companyLeaveDetails([company_uuid, leave_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/approval/leave/${leave_uuid}`, 'GET');
    }

    static getEmployees([company_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/approval/employees`, 'GET');
    }

    static getReviewList([company_uuid, startDate, endDate, employee_uuid]) {
        let url = `/api/company/${company_uuid}/approval/timesheet?type=week&startDate=${startDate}&endDate=${endDate}&pagination=0`;
        if (employee_uuid) {
            url += `&employee=${employee_uuid}`;
        }
        return ApiBaseService.request(url, 'GET');
    }
    static getCompanyReviewList([company_uuid, type, startDate, endDate, employee_uuid]) {
        let url = `/api/company/${company_uuid}/approval/timesheet?type=${type}&startDate=${startDate}&endDate=${endDate}&pagination=0`;
        if (employee_uuid) {
            url += `&employee=${employee_uuid}`;
        }
        return ApiBaseService.request(url, 'GET');
    }

    static reviewTimesheet([company_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/approval/timesheet`, 'PUT', data);
    }

    // static getCompanyMonthChart([company_uuid, startDate, endDate]) {
    //     return ApiBaseService.request(
    //         `/api/company/${company_uuid}/timesheet-project-analysis?startDate=${encodeURIComponent(
    //             startDate
    //         )}&endDate=${encodeURIComponent(endDate)}`,
    //         'GET'
    //     );
    // }

}

export default TimesheetService;
